import {
	IconBrandGithub,
	IconBrandInstagram,
	IconBrandLinkedin,
	IconBrandX,
} from "@tabler/icons-react";
import { config } from "@/data/config";

const socialClass =
	"text-foreground/65 transition-colors hover:text-foreground dark:text-foreground/70";

export default function Footer() {
	return (
		<footer className="mt-auto border-t border-border/80 bg-background">
			<div className="mx-auto max-w-6xl px-4 py-10 lg:px-8">
				<div className="flex flex-col items-center gap-6">
					<div className="flex items-center gap-5">
						{config.Socials.Twitter && (
							<a
								href={config.Socials.Twitter}
								target="_blank"
								rel="noopener noreferrer"
								className={socialClass}
								aria-label="X (Twitter)"
							>
								<IconBrandX className="size-5" />
							</a>
						)}
						{config.Socials.Github && (
							<a
								href={config.Socials.Github}
								target="_blank"
								rel="noopener noreferrer"
								className={socialClass}
								aria-label="GitHub"
							>
								<IconBrandGithub className="size-5" />
							</a>
						)}
						{config.Socials.Linkedin && (
							<a
								href={config.Socials.Linkedin}
								target="_blank"
								rel="noopener noreferrer"
								className={socialClass}
								aria-label="LinkedIn"
							>
								<IconBrandLinkedin className="size-5" />
							</a>
						)}
						{config.Socials.Instagram && (
							<a
								href={config.Socials.Instagram}
								target="_blank"
								rel="noopener noreferrer"
								className={socialClass}
								aria-label="Instagram"
							>
								<IconBrandInstagram className="size-5" />
							</a>
						)}
					</div>
					<p className="text-center text-sm text-muted-foreground text-pretty">
						&copy; {new Date().getFullYear()} {config.Name}. All rights
						reserved.
					</p>
				</div>
			</div>
		</footer>
	);
}
